<template>
  <div class="bg-white pdt-10">
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/shebei/shebeilist')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 头部选项 -->
    <div class="flex mgt-20 mgl-10">
      <div
        :class="headerActive === v.id ? 'selectCardActive' : 'selectCard'"
        v-for="v in headerSelectArr"
        :key="v.id"
        @click="header(v)"
      >
        {{ v.title }}
      </div>
    </div>

    <!-- 设备信息 -->
    <div v-if="headerActive === 1">
      <div class="mgt-10 mgl-10 mgr-10">
        <el-descriptions border>
          <el-descriptions-item label="设备名称">{{
            infoForm.name ? infoForm.name : "- -"
          }}</el-descriptions-item>
          <el-descriptions-item label="设备编号">{{
            infoForm.equipmentNum
          }}</el-descriptions-item>
          <el-descriptions-item label="设备型号">{{
            infoForm.equipmentVersion
          }}</el-descriptions-item>
          <el-descriptions-item label="所属场景">{{
            infoForm.sceneName
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="铺设模式">
            {{ infoForm.typeName }}
          </el-descriptions-item> -->
          <el-descriptions-item label="设备状态">{{
            infoForm.status === 1 ? "在线" : "离线"
          }}</el-descriptions-item>

          <el-descriptions-item label="创建时间">{{
            infoForm.createTime
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- <div class="flex mgt-30 pdb-20 mgl-10 equipmentPhotoCode">
        <div class="flex aic mgr-150">
          <span class="mgr-20">设备照片</span>
          <div class="img-placeholder">
            <div v-if="imgArr">
              <el-image
                v-for="(v, i) in imgArr"
                :key="i"
                style="width: 100px; height: 100px"
                :src="v"
                :preview-src-list="srcList"
              ></el-image>
            </div>
          </div>
        </div>
        <div class="flex aic">
          <span class="mgr-20">设备二维码</span>
          <div class="img-placeholder">
            <el-image
              v-if="qrSrc"
              style="width: 100px; height: 100px"
              :src="qrSrc"
              :preview-src-list="qrSrcList"
            ></el-image>
            <i v-else class="el-icon-picture-outline"></i>
          </div>
        </div>
      </div> -->

      <el-form
        :inline="true"
        ref="imgForm"
        :model="imgForm"
        label-width="100px"
      >
        <div class="mgt-20">
          <el-form-item label="设备照片">
            <div v-if="imgForm.imgArr > 0">
              <el-image
                class="mgr-5"
                v-for="(v, i) in imgForm.imgArr"
                :key="i"
                style="width: 100px; height: 100px"
                :src="v"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
            <div v-else class="errorImg">
              <!-- <el-image style="width: 100px; height: 100px"> -->
              <div class="no-image">
                <i class="el-icon-picture-outline"></i>
              </div>
              <!-- </el-image> -->
            </div>
          </el-form-item>
          <el-form-item label="设备二维码">
            <el-image
              style="width: 100px; height: 100px"
              :src="imgForm.qrSrc"
              :preview-src-list="qrSrcList"
            >
            </el-image>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 滤芯信息 -->
    <div v-if="headerActive === 4">
      <div class="mgt-10 mgl-10 mgr-10">
        <el-table :data="filterTable" border stripe style="width: 100%">
          <el-table-column prop="filterElementName" label="滤芯名称">
          </el-table-column>
          <el-table-column prop="changeTime" label="更换周期（天）">
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.status === 0
                    ? '停用'
                    : scope.row.status === 1
                    ? '启用'
                    : '- -'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="baifen" label="滤芯类型">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.tyoe === 1
                    ? '计量'
                    : scope.row.type === 2
                    ? '计时'
                    : '- -'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="baifen" label="剩余百分比"> </el-table-column>
          <el-table-column prop="resetNum" label="重置时间"></el-table-column>
          <el-table-column prop="endTime" label="到期时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleChong(scope.row)"
              >
                重置
              </el-button>
              <!-- <el-button type="text" size="small" @click="filterDel(scope.row)">
                删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-if="headerActive === 2">
      <!-- 价格信息 -->

      <el-table :data="doubleArray" style="width: 100%" border>
        <el-table-column prop="type" label="类型"> </el-table-column>
        <el-table-column prop="yield" label="水量"> </el-table-column>
        <el-table-column prop="price" label="价格（元）"> </el-table-column>
      </el-table>
    </div>

    <!-- 运营数据 -->
    <div v-if="headerActive === 3" class="mgt-30">
      <el-descriptions border :column="4">
        <el-descriptions-item label="订单总数">{{
          yunForm.orderNum
        }}</el-descriptions-item>
        <el-descriptions-item label="电子卡订单">{{
          yunForm.onlineCardNum
        }}</el-descriptions-item>
        <el-descriptions-item label="实物卡订单">{{
          yunForm.entityCardNum
        }}</el-descriptions-item>
        <el-descriptions-item label="微信订单">{{
          yunForm.wxNum
        }}</el-descriptions-item>
        <el-descriptions-item label="消费金额">{{
          yunForm.orderPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="电子卡消费">{{
          yunForm.onlineCardPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="实物卡消费">{{
          yunForm.entityCardPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="微信消费">{{
          yunForm.wxPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="设备购水量（L）">{{
          (yunForm.orderWater / 1000).toFixed(
            yunForm.orderWater % 1000 !== 0 ? 3 : 0
          )
        }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <!-- 登录密码确认弹框 -->
    <el-dialog
      :title="'密码确认'"
      :visible.sync="pwdSureVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input
            show-password
            v-model="pwdForm.password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdSureVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      activeName: null,
      headerSelectArr: [
        { id: 1, title: "设备信息" },
        { id: 2, title: "价格信息" },
        { id: 3, title: "运营数据" },
        { id: 4, title: "滤芯信息" },
      ],
      headerActive: 1,
      id: "",
      qrSrcList: [],
      fourIceInfo: [],
      fourHotInfo: [],
      equipmentSrc: [],
      qrSrc: "",
      filterTable: [],
      hotIceArr: [],
      infoForm: {},
      srcList: [],
      pwdSureVisible: false,
      pwdForm: {
        password: "",
      },
      filterId: null,
      imgArr: [],
      imgForm: { imgArr: [], qrSrc: "" },
      futureCustomerId: null,
      orderNumCount: null,
      orderPriceCount: null,
      yunForm: {},
      doubleArray: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.futureCustomerId = this.$route.query.futureCustomerId;
    this.getDetail();
    // this.getData();
    this.getYunData();
  },
  methods: {
    getFilter() {
      this.$api.shebei.filterList({ id: this.id }).then((res) => {
        if (res.code === 200) {
          this.filterTable = res.data;

          this.filterTable.forEach((v) => {
            v.baifen = Number(v.residueLife) * 100 + "%";
            v.endTime = this.addDaysToDate(v.createTime, v.changeTime);
          });
        }
      });
    },

    // 运营数据
    getData() {
      this.$api.shebei.operatorData({ id: this.id }).then((res) => {
        if (res.code === 200) {
          res.data.forEach((v) => {
            if (v.nowBelongToCompanyId == this.futureCustomerId) {
              this.orderNumCount += Number(v.orderNumCount);
              this.orderPriceCount += Number(v.orderPriceCount);
            }
          });
        }
      });
    },

    // 运营数据新
    getYunData() {
      this.$api.shebei
        .operatorDataNew({
          equipmentId: this.id,
          companyId: this.futureCustomerId,
        })
        .then((res) => {
          console.log(res, "最新运营数据");
          if (res.code === 200) {
            this.yunForm = res.data;
          }
        });
    },

    // 密码确认后重置
    pwdSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误，请重新输入", "error");
                this.pwdForm = { name: "" };
              } else {
                this.pwdSureVisible = false;
                handleConfirm("确认重置该滤芯吗?", "info")
                  .then(() => {
                    // 重置接口===========
                    this.$api.shebei
                      .filterYuan({ id: this.filterId })
                      .then((res) => {
                        if (res.code === 200) {
                          handleAlert("滤芯已重置", "success");
                          this.getFilter();
                        }
                      });
                  })
                  .catch(() => {
                    return;
                  });
              }
            });
        } else {
          return false;
        }
      });
    },

    // 重置按钮
    handleChong(row) {
      this.filterId = row.id;
      this.pwdSureVisible = true;
      this.pwdForm = { password: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },

    addDaysToDate(startDate, days) {
      if (
        !startDate ||
        isNaN(new Date(startDate).getTime()) ||
        typeof days !== "number"
      ) {
        return "- -"; // 或返回空字符串，根据你的需求
      }
      const startDateObj = new Date(startDate);
      const millisecondsToAdd = days * 24 * 60 * 60 * 1000;

      // 计算相加后的时间（以毫秒为单位）
      const resultTime = startDateObj.getTime() + millisecondsToAdd;

      // 创建新的Date对象来表示相加后的日期

      const resultDate = new Date(resultTime);

      // 格式化日期字符串（年-月-日 时:分:秒）
      const formattedResult = resultDate
        .toISOString()
        .replace("T", " ")
        .slice(0, 19);

      return formattedResult;
    },

    jindu(v) {
      // console.log(v, '进度');
      let startTime = new Date(v.createTime).getTime(); //开始时间
      let endTime = this.GetDateStr(v.changeTime).getTime(); //到期时间
      let currentTime = new Date().getTime(); //现在时间
      var totalTime = endTime - startTime;
      var elapsedTime = currentTime - startTime;
      var progress = (elapsedTime / totalTime) * 100;

      return parseFloat(100 - progress).toFixed(0);
    },

    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);
      return dd;
    },

    formatDate(dateStr) {
      var date = new Date(dateStr);

      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var seconds = ("0" + date.getSeconds()).slice(-2);

      var formattedDate =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;

      return formattedDate;
    },

    getDaysBetween(startDateStr, endDateStr) {
      if (startDateStr === this.formatDate(endDateStr)) {
        return 0;
      }
      var startDate = new Date(startDateStr);
      var endDate = new Date(endDateStr);

      // 将时间戳转换为毫秒级别
      var startTimestamp = startDate.getTime();
      var endTimestamp = endDate.getTime();

      // 将时间戳差值转为天数差值
      var timeDiff = Math.abs(endTimestamp - startTimestamp);
      var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return dayDiff;
    },

    // 滤芯删除
    filterDel(row) {
      if (row.status === 1) {
        handleAlert("已启用的滤芯无法删除", "error");
        return;
      }
      handleConfirm("确认删除该滤芯吗?", "info")
        .then(() => {
          this.$api.shebei.filterDel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("删除成功", "success");
              this.getFilter();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    getDetail() {
      this.$api.shebei.shebeiDetail({ id: this.id }).then((res) => {
        if (res.code === 200) {
          this.infoForm = res.data;
          this.hotIceArr = [];
          this.imgForm.qrSrc = res.data.codeMessage;
          this.qrSrcList = [];
          this.qrSrcList.push(res.data.codeMessage);
          this.imgForm.imgArr = res.data.equipmentPhoto;
          this.srcList = res.data.equipmentPhoto;

          this.equipmentSrc = res.data.equipmentPhoto;

          // res.data.futureEquipmentVerSkuBeans.forEach((v, i) => {
          //   if (v.type == 1) {
          //     this.hotIceArr.push(1);
          //     this.fourHotInfo.push(v);
          //     this.fourHotInfo.forEach((v2) => {
          //       let obj = v2.equipmentSkuInfo;
          //       v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
          //     });
          //   } else if (v.type == 3) {
          //     this.hotIceArr.push(3);
          //     this.fourIceInfo.push(v);
          //     this.fourIceInfo.forEach((v2) => {
          //       let obj = v2.equipmentSkuInfo;
          //       v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
          //     });
          //   }
          // });
          const mergedArray = Object.values(res.data.waterPriceList).flatMap(
            (value) => value
          );
          console.log(mergedArray, "mergedArray");
          mergedArray.forEach((v, index) => {
            let obj = JSON.parse(v.equipmentSkuInfo);
            v.yield = obj.出水量 + v.capacityType;
          });
          this.doubleArray = mergedArray;
        }
      });
    },
    header(v) {
      this.headerActive = v.id;
      if (this.headerActive === 4) {
        this.getFilter();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.selectCard {
  color: #626262;
  font-size: 20px;
  margin-right: 50px;
  cursor: pointer;
}
.selectCardActive {
  color: var(--accent);
  font-size: 20px;
  margin-right: 50px;
  cursor: pointer;
}
.img-placeholder {
  width: 100px;
  height: 100px;
  background-color: #e8e8e8;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  i {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
  }
}
.no-image {
  width: 90px;
  height: 90px;
  border: 1px solid var(--input-border);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ccc;
}
.equipmentPhoto {
  width: 100%;
  /deep/ .el-image {
    margin-right: 5px;
    width: 100px !important;
  }
}
</style>
